import React from 'react';
import PropTypes from 'prop-types';

const Spacer = props => {
  const rootStyle = React.useMemo(() => {
    if (Number.isNaN(props.flex)) return {
      flexGrow: 1,
      flex: 1,
    };
    return {
      flex: props.flex,
      flexGrow: props.flex,
    };
  }, [props.flex]);
  return (
    <div style={rootStyle}>{' '}</div>
  );
};

Spacer.propTypes = {
  flex: PropTypes.number,
};

export default Spacer;
